/** Premium positioning shared across every section (edition, access, support, contrast). */

export const PREMIUM = {
  edition: 'Build It · Price It · Sell It',
  editionShort: '2026 Edition',
  access: 'Free updates · Lifetime access',
  support: 'Personal email support',
  pages: '240 pages',
} as const

export const BONUS_LINE_SHORT = 'Plus 5 premium bonuses, included free.'

export const PREMIUM_SEALS: string[] = ['7-day guarantee', '2026 Edition', 'Lifetime access', 'Email support']

/** Offer: premium services box (BBQ sales-letter standard). */
export const PREMIUM_SERVICES: Array<{ title: string; text: string }> = [
  { title: 'Build & sell card on every project', text: 'Finished size, steel list and a place to work out your cost and your price.' },
  { title: 'Free updates included', text: 'New editions arrive at the same download link.' },
  { title: 'Lifetime access', text: 'One payment. Keep the PDFs on any device, forever.' },
  { title: 'Personal email support', text: 'A real person answers questions about your build.' },
]

export const CONTRAST_LINE = 'Other packs sell you 1,000 random plans. This is 30 complete welding projects that sell.'

export const INSTANT_DELIVERY = 'Receive all 6 PDF volumes and 5 bonuses by email immediately after payment.'

export interface ContrastRow {
  ours: string
  theirs: string
}

export const CONTRAST: ContrastRow[] = [
  { ours: '30 complete plans with exact cut lists in in + mm', theirs: 'A photo and a guess' },
  { ours: 'Pieces people actually buy', theirs: 'Big builds that sit unsold in the garage' },
  { ours: 'A build & sell card with steel cost, hours and your price', theirs: 'Guessing what to charge' },
  { ours: 'No plasma or CNC: chop saw, grinder, drill, welder', theirs: 'Plans that need a shop you don\'t have' },
]
